<template>
  <div class="not-login">
    <van-popup v-model="openDialog">
      <div class="content">
        <div class="title">您还未登录</div>
        <div class="message">请先登录再进行操作</div>
        <img src="../../assets/images/hisTrack/login_banner.png" alt="" srcset="">
        <div class="btn-box flex">
          <div class="btn nobtn" @click="openDialog=false">暂不登录</div>
          <div class="btn immediately" @click="gologin">立即登录</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { wxNavigateTo } from '../../utils/WeChatUtil'
import { ttNavigateTo } from '../../utils/ByteDanceUtil'
export default {
  props: {
  },
  data () {
    return {
      openDialog: false
    };
  },
  methods: {
    showPopup () {
      this.openDialog = true
    },
    gologin () {
      this.openDialog = false
      const { platform } = this.$store.state.userInfo
      console.log(this.isBytedance, platform,  '字节', window.location.href)
      if (platform === 'TENCENT_QQ_VEHICLE') {
        qq.miniProgram.navigateTo({
          url: '/pages/login/codeLogin/index'
        })
      } else if (platform === 'TENCENT_WECHAT_MP_VEHICLE') {
        wxNavigateTo('../regist/regist?unionId=&openId=&subscribe=')
      } else if (this.isBytedance) {
        ttNavigateTo('/pages/login/phoneLogin/index')
      }
    }
  }
};
</script>

<style scoped lang="scss">
.not-login>:first-child {
  background-color: rgba(0,0,0,.4)
}
.not-login>:last-child {
  border-radius: 12px;
  width: 70%;
}
.not-login {
  .content {
    padding: 30px 30px;
    text-align: center;
    .title {
      padding: 36px 0;
      font-size: 32px;
    }
    .message {
      color: #656565;
      font-size: 26px;
    }
    .btn-box {
      justify-content: space-between;
      margin-bottom: 20px;
      .btn {
        flex: .42;
        border-radius: 28px;
        font-size: 26px;
        height: 60px;
        line-height: 60px;
      }
      .nobtn {
        border: 1px solid #5572fd;
        color: #5572fd;
      }
      .immediately {
        background-color: #5572fd;
        color: #ffffff;
      }
    }
  }
}
</style>
